import React, { useState, useEffect } from 'react';
import './Navbar.css';
import { FaBars, FaTimes } from 'react-icons/fa';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { startCoinFlip } from '../components/CoinFlipTransition';

const ppLogo = '/ChatGPT Image Aug 11, 2026, 09_22_14 PM.png';

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [activeLink, setActiveLink] = useState('');
  const location = useLocation();
  const navigate = useNavigate();

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Handle active link based on scroll position (only on home page)
  useEffect(() => {
    if (location.pathname === '/') {
      const handleScrollSpy = () => {
        const sections = ['intro', 'explore', 'contact'];
        
        for (const section of sections) {
          const element = document.getElementById(section);
          if (element) {
            const rect = element.getBoundingClientRect();
            if (rect.top <= 100 && rect.bottom >= 100) {
              setActiveLink(section);
              break;
            }
          }
        }
      };

      window.addEventListener('scroll', handleScrollSpy);
      return () => window.removeEventListener('scroll', handleScrollSpy);
    }
  }, [location.pathname]);

  // Set active link based on current route
  useEffect(() => {
    if (location.pathname === '/blog' || location.pathname.startsWith('/blog/')) {
      setActiveLink('blog');
    } else if (location.pathname !== '/') {
      setActiveLink('');
    }
  }, [location.pathname]);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  const handleLogoClick = () => {
    navigate('/');
    setActiveLink('');
    closeMenu();
  };

  // Prevent body scroll when menu is open
  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [menuOpen]);

  return (
    <>
      <header className={`navbar ${scrolled ? 'scrolled' : ''}`}>
        <div className="container">
          {/* Logo Section */}
          <div className="navbar-logo" onClick={handleLogoClick}>
            <span className="navbar-logo-crop">
              <img src={ppLogo} alt="The PP Studio" className="navbar-logo-img" />
            </span>
          </div>

          {/* Menu Section */}
          <div className="navbar-menu">
            <nav className={`navbar-links ${menuOpen ? 'open' : ''}`}>
              <Link
                to="/#intro"
                onClick={closeMenu}
                className={activeLink === 'intro' ? 'active' : ''}
              >
                About Me
              </Link>
              <Link
                to="/explore"
                className={activeLink === 'explore-page' ? 'active' : ''}
                onClick={() => { setActiveLink('explore-page'); closeMenu(); }}
              >
                Explore
              </Link>
              <Link
                to="/contract-compass"
                className={activeLink === 'compass' ? 'active' : ''}
                onClick={() => { setActiveLink('compass'); closeMenu(); }}
              >
                Contract Help
              </Link>
              <Link
                to="/guidance"
                className={`pp-guidance-link ${activeLink === 'guidance' ? 'active' : ''}`}
                onClick={() => { setActiveLink('guidance'); closeMenu(); }}
              >
                Mentoring
              </Link>
              <Link
                to="/#contact"
                onClick={closeMenu}
                className={activeLink === 'contact' ? 'active' : ''}
              >
                Contact
              </Link>
              <Link
                to="/blog"
                className={`pp-edit-link ${activeLink === 'blog' ? 'active' : ''}`}
                onClick={(e) => {
                  e.preventDefault();
                  setActiveLink('blog');
                  closeMenu();
                  startCoinFlip('/blog');
                }}
              >
                <span>The PP Edit</span>
              </Link>
            </nav>

            {/* Mobile Menu Icon */}
            <div 
              className="menu-icon" 
              onClick={toggleMenu}
              aria-label="Toggle menu"
              role="button"
              tabIndex={0}
              onKeyPress={(e) => e.key === 'Enter' && toggleMenu()}
            >
              {menuOpen ? <FaTimes size={22} /> : <FaBars size={22} />}
            </div>
          </div>
        </div>
      </header>

      {/* Mobile Menu Overlay */}
      <div 
        className={`navbar-overlay ${menuOpen ? 'active' : ''}`}
        onClick={closeMenu}
        aria-hidden="true"
      />
    </>
  );
}

export default Navbar;
